import { api } from "../App"; // paymentsActions.js
import {
  // create_payment_intent
  startCreatePaymentIntent,
  createPaymentIntentSuccess,
  createPaymentIntentError,

  // confirm_subscription
  startConfirmSubscription,
  confirmSubscriptionSuccess,
  confirmSubscriptionError,

  // verify_subscription
  startVerifySubscription,
  verifySubscriptionSuccess,
  verifySubscriptionError,

  // subscription_status
  startSubscriptionStatus,
  subscriptionStatusSuccess,
  subscriptionStatusError,

  // cancel_subscription
  startCancelSubscription,
  cancelSubscriptionSuccess,
  cancelSubscriptionError,

  // resume_subscription
  startResumeSubscription,
  resumeSubscriptionSuccess,
  resumeSubscriptionError,

  // invoices
  startListInvoices,
  listInvoicesSuccess,
  listInvoicesError,

  // confirm_payment
  startConfirmPayment,
  confirmPaymentSuccess,
  confirmPaymentError,

  // upgrade_quote
  startUpgradeQuote,
  upgradeQuoteSuccess,
  upgradeQuoteError,

  // create_upgrade_intent
  startCreateUpgradeIntent,
  createUpgradeIntentSuccess,
  createUpgradeIntentError,

  // confirm_upgrade_after_payment
  startConfirmUpgradeAfterPayment,
  confirmUpgradeAfterPaymentSuccess,
  confirmUpgradeAfterPaymentError,
} from "../reducers/paymentReducers";

// --------- helpers ----------
const buildAuthConfig = (getState) => {
  const {
    userLogin: { userInfo },
  } = getState();
  if (userInfo?.token) {
    return {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.token}`,
      },
    };
  }
  return { headers: { nothing: "nothing" } };
};

const normErr = (error) =>
  (error.response &&
    (error.response.data?.detail || error.response.data?.message)) ||
  error.message;

// --------- thunks ----------

// POST /create_payment_intent/<restaurant_id>/<subscription_number>/<payment_method>/
export const createPaymentIntent =
  ({ restaurantId, subscriptionNumber, paymentMethod, body = {} }) =>
  async (dispatch, getState) => {
    try {
      dispatch(startCreatePaymentIntent());
      const config = buildAuthConfig(getState);
      const { data } = await api.post(
        `/payments/create_payment_intent/${restaurantId}/${subscriptionNumber}/${paymentMethod}/`,
        body,
        config
      );
      dispatch(createPaymentIntentSuccess(data));
    } catch (error) {
      dispatch(createPaymentIntentError(normErr(error)));
    }
  };

// POST /confirm_subscription/<restaurant_id>/<subscription_number>/<token>/<isToSaveCard>/
export const confirmSubscription =
  ({ restaurantId, subscriptionNumber, token, isToSaveCard, body = {} }) =>
  async (dispatch, getState) => {
    try {
      dispatch(startConfirmSubscription());
      const config = buildAuthConfig(getState);
      const { data } = await api.post(
        `/payments/confirm_subscription/${restaurantId}/${subscriptionNumber}/${token}/${isToSaveCard}/`,
        body,
        config
      );
      dispatch(confirmSubscriptionSuccess(data));
    } catch (error) {
      dispatch(confirmSubscriptionError(normErr(error)));
    }
  };

// GET /verify_subscription/<restaurant_id>/
export const verifySubscription =
  ({ restaurantId }) =>
  async (dispatch, getState) => {
    try {
      dispatch(startVerifySubscription());
      const config = buildAuthConfig(getState);
      const { data } = await api.get(
        `/payments/verify_subscription/${restaurantId}/`,
        config
      );
      dispatch(verifySubscriptionSuccess(data));
    } catch (error) {
      dispatch(verifySubscriptionError(normErr(error)));
    }
  };

// GET /subscription_status/<restaurant_id>/
export const fetchSubscriptionStatus =
  ({ restaurant_id }) =>
  async (dispatch, getState) => {
    try {
      dispatch(startSubscriptionStatus());
      console.log("print inside action restaurant_id: ", restaurant_id);
      const config = buildAuthConfig(getState);
      const { data } = await api.get(
        `/payments/subscription_status/${restaurant_id}/`,
        config
      );
      dispatch(subscriptionStatusSuccess(data));
      return data;
    } catch (error) {
      dispatch(subscriptionStatusError(normErr(error)));
    }
  };

// POST /cancel_subscription/<restaurant_id>/
export const cancelSubscription =
  ({ restaurant_id, body = {} }) =>
  async (dispatch, getState) => {
    try {
      dispatch(startCancelSubscription());
      const config = buildAuthConfig(getState);
      const { data } = await api.post(
        `/payments/cancel_subscription/${restaurant_id}/`,
        body,
        config
      );
      dispatch(cancelSubscriptionSuccess(data));
    } catch (error) {
      dispatch(cancelSubscriptionError(normErr(error)));
    }
  };

// POST /resume_subscription/<restaurant_id>/
export const resumeSubscription =
  ({ restaurant_id, body = {} }) =>
  async (dispatch, getState) => {
    try {
      dispatch(startResumeSubscription());
      const config = buildAuthConfig(getState);
      const { data } = await api.post(
        `/payments/resume_subscription/${restaurant_id}/`,
        body,
        config
      );
      dispatch(resumeSubscriptionSuccess(data));
    } catch (error) {
      dispatch(resumeSubscriptionError(normErr(error)));
    }
  };

// GET /invoices/<restaurant_id>/
export const listInvoices =
  ({ restaurantId }) =>
  async (dispatch, getState) => {
    try {
      dispatch(startListInvoices());
      const config = buildAuthConfig(getState);
      const { data } = await api.get(
        `/payments/invoices/${restaurantId}/`,
        config
      );
      dispatch(listInvoicesSuccess(data.invoices)); // { invoices: [...] }
      console.log("data inside list action: ", data);
      return data.invoices; // <-- let callers await/use it
    } catch (error) {
      const msg = normErr(error);
      dispatch(listInvoicesError(msg));
      throw new Error(msg); // optional: bubble to component
    }
  };

// POST /confirm_payment/<restaurant_id>/<payment_method>/<payment_id>/
export const confirmPayment =
  ({ restaurantId, paymentMethod, paymentId, body = {} }) =>
  async (dispatch, getState) => {
    try {
      dispatch(startConfirmPayment());
      const config = buildAuthConfig(getState);
      const { data } = await api.post(
        `/payments/confirm_payment/${restaurantId}/${paymentMethod}/${paymentId}/`,
        body,
        config
      );
      dispatch(confirmPaymentSuccess(data));
    } catch (error) {
      dispatch(confirmPaymentError(normErr(error)));
    }
  };

// POST /upgrade_quote/<restaurant_id>/
export const createUpgradeQuote =
  ({ restaurantId, body = {} }) =>
  async (dispatch, getState) => {
    try {
      dispatch(startUpgradeQuote());
      const config = buildAuthConfig(getState);
      const { data } = await api.post(
        `/payments/upgrade_quote/${restaurantId}/`,
        body,
        config
      );
      dispatch(upgradeQuoteSuccess(data));
    } catch (error) {
      dispatch(upgradeQuoteError(normErr(error)));
    }
  };

// POST /create_upgrade_intent/<restaurant_id>/
export const createUpgradeIntent =
  ({ restaurantId, body = {} }) =>
  async (dispatch, getState) => {
    try {
      dispatch(startCreateUpgradeIntent());
      const config = buildAuthConfig(getState);
      const { data } = await api.post(
        `/payments/create_upgrade_intent/${restaurantId}/`,
        body,
        config
      );
      dispatch(createUpgradeIntentSuccess(data));
    } catch (error) {
      dispatch(createUpgradeIntentError(normErr(error)));
    }
  };

// POST /confirm_upgrade_after_payment/<restaurant_id>/
export const confirmUpgradeAfterPayment =
  ({ restaurantId, body = {} }) =>
  async (dispatch, getState) => {
    try {
      dispatch(startConfirmUpgradeAfterPayment());
      const config = buildAuthConfig(getState);
      const { data } = await api.post(
        `/payments/confirm_upgrade_after_payment/${restaurantId}/`,
        body,
        config
      );
      dispatch(confirmUpgradeAfterPaymentSuccess(data));
    } catch (error) {
      dispatch(confirmUpgradeAfterPaymentError(normErr(error)));
    }
  };
